export default __webpack_public_path__ + "static/media/arw-04234.65c0b54e.jpg";